var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenRulerSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen-ruler-solid",
    d: "M6.1,2.1l-1.75,1.75L4,4.206,3.294,3.5l.353-.353L5.4,1.4,4,0,0,4,3.294,7.294l4-4ZM12,16l4-4-1.4-1.4-1.75,1.75-.353.353L11.794,12l.353-.353L13.9,9.9,12.706,8.706l-4,4ZM1,11,0,16l5-1,8.147-8.147-4-4ZM16,4,12,0,9.853,2.147l4,4Z",
    fill: "#2186eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenRulerSolid);
export default __webpack_public_path__ + "static/media/pen-ruler-solid.992c981afbb6c8a6b7c632a8032b6301.svg";
export { ForwardRef as ReactComponent };